export const exportFloatFormat = (number) => {
    number = parseFloat(number)

    return replacePointWithComma(number)
};

export const replacePointWithComma = (number) => {
    return number.toString().replace('.', ',')
};
